export const TAG_BAR_MAX_OFFSET_HEIGHT = 56 // px
